import styled, { css } from 'styled-components';
import { colors, colorUtils, layout } from '@prisjakt/ui-base';

type CollapsibleWrapperProps = {
  collapsed: boolean;
};

export const CollapsibleWrapper = styled.div<CollapsibleWrapperProps>`
  position: relative;
  ${({ collapsed }) =>
    collapsed &&
    css`
      max-height: 3em;
      overflow: hidden;
      /* Fade out towards the bottom */
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2em;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.8)
        );
      }
    `}
`;

export const ExpandButton = styled.button.attrs({ type: 'button' })`
  background: transparent;
  color: transparent;
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transition: background-color ${layout.animations.buttonTransition};
  width: 100%;
  z-index: 1;

  &:focus {
    background-color: ${colorUtils.setRgbaAlpha(colors.lightBlue1, '0.5')};
  }
`;
